import { LOCALES } from 'state/intl/types';

export enum PROD_SUPPORTED_LOCALES {
  en_us = LOCALES.en_us,
}

export const SORTED_PROD_SUPPORTED_LOCALES = [LOCALES.en_us];
